﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../utilities/crud-functions';
import AnalysisData from './AnalysisData';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import { Popup as DialogPopup }  from 'devextreme-react/popup';
import Button from 'devextreme-react/button';
//import { DashboardControl, Extensions, DataSourceWizard } from 'devexpress-dashboard-react';

let key = 1;

export default function DmaDashboard() {
        
    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        //getAnalysisData();
    }, []);

    key++;

    return (
        <div className="pw-content">

            {/*
            <div style={{ position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
                <DashboardControl style={{ height: '100%' }}
                    workingMode='Designer'
                    endpoint="https://localhost:44356/api/dashboard">

                    <Extensions>
                        <DataSourceWizard allowCreateNewJsonConnection="true" enableCustomSql="true" />
                    </Extensions>
                </DashboardControl>
            </div>
            */}


        </div>

    );



}